import * as Yup from 'yup';

export const officePlanFormSchema = Yup.object().shape({
  planName: Yup.string().required('Blue print name is required'),
  planFileTypeID: Yup.string().required('File type is required'),
});
